import { db } from "../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  deleteDoc,
  serverTimestamp,
  query,
  orderBy,
} from "firebase/firestore";

// Registry of admin-created custom pages (Edit Site CMS "+ New Page").
// Each doc's id IS the page's slug, which doubles as its `siteContent`
// pageKey (so the existing draft/publish block-content plumbing in
// siteContentService.js needs no changes) and its public URL segment
// (`/page/{slug}`). See blockRegistry.js's BUILTIN_PAGE_KEYS for how a
// pageKey is told apart from the fixed pages in PAGES.
const CUSTOM_PAGES_COLLECTION = "customPages";

/** All custom pages, newest first — for the "Edit Site" page picker. */
export async function listCustomPages() {
  const snap = await getDocs(
    query(collection(db, CUSTOM_PAGES_COLLECTION), orderBy("createdAt", "desc")),
  );
  return snap.docs.map((d) => ({ slug: d.id, ...d.data() }));
}

/** One custom page's registry entry (title, etc.) — null if it doesn't
 * exist, which the public `/page/:slug` route treats as a 404 even if a
 * `siteContent` doc happens to still exist under that slug. */
export async function getCustomPage(slug) {
  const snap = await getDoc(doc(db, CUSTOM_PAGES_COLLECTION, slug));
  return snap.exists() ? { slug, ...snap.data() } : null;
}

/** Registers a new custom page. Callers must already have checked the
 * slug doesn't collide with a fixed page or an existing custom page. */
export async function createCustomPage(slug, title) {
  await setDoc(doc(db, CUSTOM_PAGES_COLLECTION, slug), {
    title,
    createdAt: serverTimestamp(),
  });
}

/** Removes a custom page from the registry (and the public site/nav) —
 * its `siteContent` draft/published blocks are left alone in case the
 * slug is ever reused, but are unreachable without a registry entry. */
export async function deleteCustomPage(slug) {
  await deleteDoc(doc(db, CUSTOM_PAGES_COLLECTION, slug));
}
